module.exports = __webpack_public_path__ + "media/images/front/treatment_support/icon_trend_up-aab4b9c85675e64d05838a552c880dc8.svg";